import { jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import classNames from "classnames";
import { Icon, Popover } from "@blueprintjs/core";
export const ColumnFilterMenu = ({
  addFilters,
  compact,
  currentFilter,
  currentParams,
  dataType,
  extraCompact,
  filterActiveForColumn,
  FilterMenu,
  filterOn,
  removeSingleFilter,
  schemaForField,
  setNewParams,
  formName
}) => {
  const [columnFilterMenuOpen, setColumnFilterMenuOpen] = useState(false);
  return /* @__PURE__ */ jsx(
    Popover,
    {
      position: "bottom",
      onClose: () => setColumnFilterMenuOpen(false),
      isOpen: columnFilterMenuOpen,
      modifiers: {
        preventOverflow: { enabled: true },
        hide: { enabled: false },
        flip: { enabled: false }
      },
      content: /* @__PURE__ */ jsx(
        FilterMenu,
        {
          formName,
          addFilters,
          compact,
          currentFilter,
          currentParams,
          dataType,
          filterOn,
          removeSingleFilter,
          schemaForField,
          setNewParams,
          togglePopover: () => setColumnFilterMenuOpen(false)
        }
      ),
      children: /* @__PURE__ */ jsx(
        Icon,
        {
          style: { marginLeft: 5 },
          icon: "filter",
          size: extraCompact ? 14 : void 0,
          onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            setColumnFilterMenuOpen((prev) => !prev);
          },
          className: classNames("tg-filter-menu-button", {
            "tg-active-filter": !!filterActiveForColumn
          })
        }
      )
    }
  );
};
